/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Manual_DescInputs */

const vi_einvoice_manual_desc = /** @type {(inputs: Einvoice_Manual_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhập hóa đơn bạn đã xuất trên MISA để đơn này khỏi nằm trong danh sách chờ.`)
};

/**

* @param {Einvoice_Manual_DescInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_manual_desc = /** @type {((inputs?: Einvoice_Manual_DescInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Manual_DescInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_manual_desc(inputs)
});